/**
 * Normalize feed/API team codes to the filenames used under picks-core/mlb/
 * (jerseys/*.png, teams/*.svg). Mirrors admin `MLB_TEAM_ABBR_MAP` in jersey-mapping.
 *
 * Blob does not duplicate every feed alias; map aliases here instead of renaming assets.
 */
export const MLB_BLOB_TEAM_CODE_MAP: Record<string, string> = {
  // Feed often uses AZ; blob stores ARI.png
  AZ: 'ARI',
  // Naive 3-letter truncation of "Diamondbacks" → DIA; blob uses ARI.svg
  DIA: 'ARI',
  // Some sources still use ANA for Angels; blob stores LAA.png
  ANA: 'LAA',
};

export function normalizeMlbBlobTeamCode(teamCode: string | null | undefined): string {
  if (!teamCode || typeof teamCode !== 'string') return '';
  const code = teamCode.trim().toUpperCase().slice(0, 3);
  return MLB_BLOB_TEAM_CODE_MAP[code] ?? code;
}
